import { fromJS, Map } from 'immutable';

import { addToast, clearToast } from './actions';

const defaultState = Map({
  content: null,
  isVisible: false,
  message: '',
  type: ''
});

export default function toast(state = defaultState, action) {
  const newState = fromJS(state);

  switch (action.type) {
    case addToast.type:
      return newState
        .set('content', action.payload)
        .set('message', action.payload.message)
        .set('type', action.payload.type)
        .set('isVisible', true);

    case clearToast.type:
      return newState.set('content', null).set('isVisible', false);

    default:
      return newState;
  }
}

export const selectToast = state => state.toast.get('content');
export const getToastAttribute = (state, attributeName) => state.toast.get(attributeName);
